import "./Section.scss";

import React from "react";

interface SectionProps {
  className?: string;
  center?: boolean;
  children: React.ReactNode;
  extraPadding?: boolean;
}

interface PaperProps extends SectionProps {
  colorShadow?: boolean;
}

export const Section: React.FC<SectionProps> = ({
  children,
  center,
  className,
  extraPadding = false
}) => {
  return (
    <section
      className={`section ${className} ${center ? "center" : ""} ${
        extraPadding ? "extraPadding" : ""
      }`}
    >
      {children}
    </section>
  );
};

export const Paper: React.FC<PaperProps> = ({
  children,
  center,
  className,
  colorShadow = false
}) => {
  return (
    <section
      className={`paper ${className} ${center ? "center" : ""} ${
        colorShadow ? "paper-color" : ""
      }`}
    >
      {children}
    </section>
  );
};

export default Section;
